import { Button } from "./Button";
import { Root } from "./Root";

export const LinkToolbar = {
  Root,
  Button,
  Select: () => null,
};
